export const USER_PREF="com.brentsys.system_id.user";
export const TOKEN_PREF="com.brentsys.system_id.token";
export const FCM_TOKEN = "com.brentsys.system_id.fcm_token";
export const FCM_PERMISSION = "com.brentsys.system_id.fcm_permission";
export const ARCH_ROLES_PREF="com.brentsys.kash.arch_roles";